import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import * as Linking from "expo-linking";
import { FontAwesome } from "@expo/vector-icons";

import { WEB_PRIVACY_URL, WEB_TERMS_URL } from "@/utils/links";

interface TermsOfServiceProps {
  agreedToTerms: boolean;
  setAgreedToTerms: (value: boolean) => void;
}

function TermsOfService({
  agreedToTerms,
  setAgreedToTerms,
}: TermsOfServiceProps): React.JSX.Element {
  const openTermsOfService = (): void => {
    Linking.openURL(WEB_TERMS_URL);
  };

  const openPrivacyPolicy = (): void => {
    Linking.openURL(WEB_PRIVACY_URL);
  };

  return (
    <View style={styles.agreementContainer}>
      <TouchableOpacity
        testID="terms-checkbox"
        style={styles.checkbox}
        onPress={() => setAgreedToTerms(!agreedToTerms)}
      >
        {agreedToTerms && (
          <FontAwesome name="check" size={18} color="#4299E1" />
        )}
      </TouchableOpacity>
      <Text style={styles.agreementText}>
        I agree to the{" "}
        <Text style={styles.link} onPress={openTermsOfService}>
          Terms of Service
        </Text>{" "}
        and{" "}
        <Text style={styles.link} onPress={openPrivacyPolicy}>
          Privacy Policy
        </Text>
        {"."} I confirm that I am at least 18 years old.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  agreementContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderWidth: 2,
    borderColor: "#4A5568",
    borderRadius: 4,
    marginRight: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  agreementText: {
    flex: 1,
    fontSize: 14,
    color: "#4A5568",
  },
  link: {
    color: "#4299E1",
    textDecorationLine: "underline",
  },
});

export default TermsOfService;
